import {ChevronRightIcon} from '@primer/octicons-react'
import {ActionList, type ActionListItemProps} from '@primer/react'

import type {AutocompleteCategory} from './categories'

interface CategorySuggestionProps extends ActionListItemProps {
  category: AutocompleteCategory
}

export function CategorySuggestion({category: {name, icon: Icon}, ...props}: CategorySuggestionProps) {
  return (
    <ActionList.Item {...props}>
      <ActionList.LeadingVisual>
        <Icon />
      </ActionList.LeadingVisual>
      {name}
      <ActionList.TrailingVisual>
        <ChevronRightIcon />
      </ActionList.TrailingVisual>
    </ActionList.Item>
  )
}

try{ CategorySuggestion.displayName ||= 'CategorySuggestion' } catch {}